module.exports = __webpack_public_path__ + "img/bg-share-code-post.eca3f3c3.png";